import { useEffect, useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import type { AuthenticatedUser } from "@ranfac/shared";
import { fetchMe } from "../api.js";

export function Layout({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthenticatedUser | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    fetchMe()
      .then(setUser)
      .catch((e) => setErr(String(e)));
  }, []);

  return (
    <div className="layout">
      <header className="app">
        <div className="brand">
          <Link to="/">Ranfac Close</Link>
          <span
            style={{
              opacity: 0.7,
              marginLeft: 10,
              fontWeight: 400,
              fontSize: 12,
            }}
          >
            Month-End Close Automation · Dev Scaffold
          </span>
        </div>
        <div className="user">
          {user ? (
            <>
              <strong>{user.displayName}</strong>
              <div style={{ opacity: 0.8 }}>
                {user.roles.join(", ") || "no roles"}
              </div>
            </>
          ) : err ? (
            <span style={{ color: "#fecaca" }}>auth error</span>
          ) : (
            <span style={{ opacity: 0.6 }}>signing in…</span>
          )}
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
